<template>
  <div :class="['input-address', size]">
    <div v-if="change" class="type-change" @click="changeType">{{ typeText }}</div>
    <div class="input-group">
      <input ref="input" type="text" v-model="address" :readonly="readonly" class="address-input-field" :placeholder="placeholder" @keypress.prevent.enter="onSearch">
      <span class="input-group-btn">
        <button class="btn k-primary address-btn" type="button" @click="onSearch">
          <i :class="['glyphicon', { 'glyphicon-search': !multiple || addressList.length === 0 }, { 'glyphicon-plus': multiple && addressList.length > 0 }]"></i>
        </button>
      </span>
    </div>
    <div class="results">
      <div class="address-search-list" v-if="addressResultList.length > 0 || noResult">
        <img src="http://i1.daumcdn.net/localimg/localimages/07/postcode/320/close.png" class='close' @click="close" alt="접기 버튼">
        <ul class="list-unstyled">
          <li class="item-address" v-for="item in addressResultList" @click="selectAddress(item)">
            <div>
              <label>지번</label>
              <span class="address" :data-lat="item.lat" :data-lng="item.lng">{{ item.address }}</span>
            </div>
            <div>
              <label>도로명</label><span class="new-address">{{ item.newAddress }}</span>
            </div>
          </li>
          <li v-if="noResult" class="alert alert-danger margin-0">
            검색 결과가 없습니다.<br/>
            찾으시려는 지번 또는 도로명주소+건물번호까지 상세히 입력 후 검색해 주세요.
          </li>
        </ul>
      </div>
      <div class="address-list" v-if="addressList.length > 0 && multiple">
        <ul class="list-unstyled">
          <li class="item-address" v-for="item in addressList">
            <!--<img src="../assets/icon-location.png" v-if="item.type === 'search'"/>-->
            <span class="address">{{ item.address }}</span>
            <i class="delete glyphicon glyphicon-remove" @click="deleteAddress(item)"></i>
          </li>
        </ul>
      </div>
    </div>
    <modal ref="addressModal" :id="addressModal.id" :type="addressModal.type" :title="addressModal.title"
           :size="addressModal.size" :fields="addressModal.fields"></modal>
  </div>
</template>

<script>
  import Modal from 'common/components/Modal'

  export default {
    name: 'input-address',
    components: { Modal },
    props: {
      name: {
        type: String,
        default: function () {
          return ''
        }
      },
      size: {
        type: String,
        default: function () {
          return 'input-address-lg'
        }
      },
      readonly: {
        type: String
      },
      placeholder: {
        type: String,
        default: '주소를 입력하세요.'
      },
      change: {
        type: Boolean,
        default: function () {
          return true
        }
      },
      multiple: {
        type: Boolean,
        default: false
      },
      max: {
        type: Number,
        default: 10
      },
      value: {
        default: ''
      },
      valueChange: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      defaultAddressType: {
        type: String,
        default: 'jibun'
      },
      theme: {
        type: String
      },
      modalId: {
        type: String,
        default: 'addressModal'
      }
    },
    data: function () {
      return {
        address: '',
        addressList: [],
        addressResultList: [],
        typeText: '주소조회가 안되나요?',
        isTextMode: false,
        isSearch: true,
        noResult: false,
        isResultOpen: false,
        addressModal: {
          id: this.modalId,
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      parseAddress: function () {
        /**
         *  주소값은 두가지 상태를 가진다.
         *  단일주소 또는 다중주소 상태이다.
         *  단일주소는 별도에 변환을 거치지 않는다.
         *  다중주소는 문자열을 배열로 변환한다.
         *  배열로 변환 시 문자열에 '|' 로 각 값을 구분한다.
         */

        const isMultiple = this.multiple
        const address = isMultiple ? this.addressList : this.address


        if (isMultiple) {
          let list = []
          address.forEach(function (v, i) {
            list.push((v.type === 'direct') ? '*' + v.address : v.address)
          })

          return list.join('|')
        } else {
          return address
        }
      }
    },
    watch: {
      value: function (val) {
        // 부모창으로 부터 전달받은 데이터가 변경 될 때 마다 컴포넌트 데이터를 변경해준다.
        if (this.valueChange) {
          this.address = val
        }
      },
      address: function () {
        this.$emit('input', this.parseAddress)
      }
    },
    methods: {
      onSearch: _.debounce(function () {
        const vm = this
        const address = vm.address
        const geocoder = new daum.maps.services.Geocoder()
        const isSearch = vm.isSearch
        const addressResultList = vm.addressResultList
        const hasResult = addressResultList.length > 0

        // 검색결과 유무 플래그 초기화
        vm.noResult = false

        // 검색 모드가 아니며 검색 결과값이 있을 경우, 검색 목록에 0번째를 주소 목록에 넣어준다.
        if (!isSearch && hasResult) {
          vm.selectAddress(addressResultList[0])
        }

        // 주소가 입력되었을 경우에만 실행한다.
        if (address !== '') {
          // 수동 입력 모드인 경우, 입력된 주소를 주소목록에 그대로 넣어준다.
          if (vm.isTextMode) {
            vm.selectAddress({'type': 'direct', 'address': address})
          } else {
            // 검색 모드이며 검색된 결과값이 없을 경우 실행
            if (isSearch && !hasResult) {
              // 카카오 주소 API로 입력된 주소지에 상세정보를 불러온다.
              geocoder.addressSearch(address, function (result, status) {
                let _count = 0
                let results = result
                let template = {
                  type: 'search',
                  lat: '',
                  lng: '',
                  address: '',
                  newAddress: ''
                }

                // 정상적으로 검색이 완료 되었을 경우
                if (status === daum.maps.services.Status.OK) {
                  // 검색대기 상태를 False로 변경 (추가 검색 X)
                  vm.isSearch = false

                  // 검색 결과를 가공한다.
                  results.forEach(function (result, i) {
                    // 해당 주소지의 건물명이 있을 경우, 건물명을 출력한다.
                    let building = ''

                    if (result.road_address !== null) {
                      building = result['road_address']['building_name']
                      building = building !== '' ? ` (${building})` : ''
                    }

                    let address = result['address']['address_name']
                    let newAddress = result['road_address']
                    if (newAddress) {
                      newAddress = result['road_address']['address_name'] + building
                    } else {
                      newAddress = '도로명 주소가 없습니다.'
                    }

                    template['lng'] = result.x
                    template['lat'] = result.y
                    template['address'] = address
                    template['newAddress'] = newAddress
                    _count++

                    // 주소 목록에 상세정보를 담는다.
                    vm.addressResultList.push(_.clone(template))
                  })
                }

                // 검색 결과가 없을 경우 실행한다.
                if (_count === 0) {
                  vm.noResult = true
                }
              })
            }
          }
        }
      }, 100),
      selectAddress: function (item) {
        // 검색대기상태로 초기화.
        this.isSearch = true

        // multiple가 true 일 경우, 다중 선택이 가능한 리스트 박스 & 데이터를 생성
        if (this.multiple) {
          // 해당 주소가 이미 입력되어있는지 확인한다.
          if (!_.find(this.addressList, { 'address': item.address })) {
            // 지정된 최대 입력주소수를 체크, 기본값은 10개이다.
            if (this.addressList.length >= this.max) {
              this.addressModal.fields[0].message = ['최대 ' + this.max + '개 주소지만 등록가능합니다.']
              this.$refs.addressModal.show()
            } else {
              this.addressList.push(item)
            }
          } else {
            this.addressModal.fields[0].message = ['이미 등록된 주소입니다.']
            this.$refs.addressModal.show()
          }

          // 입력된 주소값 초기화
          this.address = ''
        } else { // multiple가 아닌 single address 일 경우, input에 데이터 추가
          // 새로운 주소가 없다면 새로운 주소에도 마찬가지로 구주소를 입력
          const newAddress = (item.newAddress && item.newAddress !== '') ? item.newAddress : item.address

          // 새로운 주소가 입력되는 시스템이면 새로운 주소를 반환한다.
          this.address = (this.defaultAddressType === 'jibun') ? item.address : newAddress
        }

        this.addressResultList = []
      },
      deleteAddress: function (item) {
        const index = this.addressList.findIndex((p) => p.address === item.address)

        if (index !== -1) {
          this.addressList.splice(index, 1)
        }

        this.$emit('input', this.parseAddress)
      },
      changeType: function () {
        /**
         *  주소 입력 시 검색 또는 직접입력 두가지 상태를 가진다.
         *  검색대기 상태는 카카오 주소 API를 활용하여 입력된 주소에 상세정보를 검색한다.
         *  직접입력 상태는 별도에 API 호출없이 입력된 텍스트를 사용한다.
         *  해당 상태에 따라 값을 초기화한다.
         */

        const vm = this
        const isTextMode = vm.isTextMode

        // 직접입력 상태 일 경우
        if (isTextMode) {
          vm.isTextMode = false
          vm.typeText = '주소조회가 안되나요?'
        } else {
          // 검색대기 상태 일 경우
          vm.isTextMode = true
          vm.noResult = false
          vm.addressResultList = []
          vm.typeText = '주소검색으로 돌아가기'
        }
      },
      close: function () {
        const vm = this

        // 검색모드, 결과유무, 검색결과 값 초기화
        vm.isSearch = true
        vm.noResult = false
        vm.addressResultList = []
      }
    },
    mounted: function () {
      const vm = this
      // 초기에 들어온 값을 통해 parsing
      let addressList = []
      if (this.value && this.value !== '') {
        // 만약 multiple가 활성화 되지 않았을 경우 넘어온 데이터를 input에 바로 넣어준다
        if (!this.multiple) {
          this.address = this.value
          return
        }
        // multiple 속성이 true인 경우
        addressList = this.value.split('|')

        addressList.forEach(function (address, i) {
          let data = {}
          // *이 포함된 경우에는 직접 입력한 경우
          data['type'] = (_.includes(address, '*')) ? 'direct' : 'search'
          data['address'] = address.replace(/\*/gi, '')

          vm.addressList.push(data)
        })
      }
    }
  }
</script>

<style lang="scss">
  .input-address {
    &.is-invalid .input-group input {
      box-shadow: inset 0 0 0 2px $hzc-red-05;
      background-blend-mode: multiply;
      background-image: linear-gradient(to bottom, $hzc-red-00, $hzc-red-00);
    }

    .type-change {
      font-size: 12px;
      text-align: right;
      color: $brand-info;
      letter-spacing: -0.3px;
      position: absolute;
      top: -20px;
      right: 0;
      cursor: pointer;
    }

    .input-group {
      height: 100%;
      position: relative;

      input {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        color: $header-color;
        outline: none;
        border: 1px solid $border-color;
        border-radius: 4px 0 0 4px;
        box-shadow: initial;

        &:focus {
          outline: none;
          box-shadow: inset 0 0 0 2px #9b88e9;
        }
      }

      .input-group-btn {
        height: 100%;
        padding: 0;
        .btn {
          width: 48px;
          color: #333333;
          background: #232a3a;
          border: 1px solid #232a3a;
          outline-width: 1px;
          border-radius: 0 4px 4px 0;
        }
        .glyphicon {
          color: $hzc-white;
        }
      }
    }

    .results {
      .address-search-list {
        overflow: auto;
        border-width: 0 1px 1px 1px;
        border-style: solid;
        border-color: $hzc-gray-04;
        width: 100%;
        max-height: 300px;
        position: relative;
        background: #ffffff;

        li {
          padding: 16px;
        }

        .new-address {
          color: #BBB;
        }

        label {
          border: 1px solid #d4e2ef;
          padding: 1px 5px;
          line-height: 1.4;
          border-radius: 3px !important;
          font-size: 12px;
          color: #008bd3;
          margin-right: 5px;
          width: 50px;
          text-align: center;
        }

        .item-address {
          cursor: pointer;
          border-bottom: 1px solid $hzc-gray-04;
          &:last-child {
            border: 0;
          }
        }

        .label {
          border: 1px solid #d4e2ef;
          padding: 1px 5px;
          line-height: 1.4;
          border-radius: 3px !important;
          font-size: 12px;
          color: #008bd3;
          margin-right: 5px;
          width: 50px;
          text-align: center;
        }

        .new-address {
          color: #BBB;
        }
      }
      .address-list {
        margin: 0;
        padding: 0;
        border-width: 0 1px 1px 1px;
        border-style: solid;
        border-color: $hzc-gray-04;
        border-radius: 0;
        background-color: $hzc-white;

        .item-address {
          padding: 4px 16px;
          font-size: 14px;
          &:first-child {
            padding-top: 8px;
          }
          &:last-child {
            padding-bottom: 8px;
          }
          .marker {
            color: #f76707;
            margin-right: 5px;
            vertical-align: text-top;
          }
          .delete {
            top: 3px;
            cursor: pointer;
            vertical-align: middle;
            display: inline-block;
            float: right;
            font-size: 12px;
          }
        }
      }
      .close {
        cursor: pointer;
        position: absolute;
        right: 0px;
        top: -1px;
        z-index: 1
      }
    }

    .list-unstyled {
      margin-bottom: 0;
    }
  }

  .input-address-lg {
    .address-input-field {
      width: 100%;
      height: 48px;
      padding: 16px;
    }
    .address-btn {
      height: 48px;
      padding: 9px 8px;
    }
  }

  .input-address-md {
    .address-input-field {
      width: 100%;
      height: 32px;
      padding: 8px;
    }
    .address-btn {
      height: 32px;
      padding: 6px 8px;
    }
  }

  .input-address-xs {
    .address-input-field {
      width: 100%;
      height: 24px;
      padding: 4px;
    }
    .address-btn {
      height: 24px;
      padding: 3px 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// ../common/components/InputAddress.vue